/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Stat_Total_DurationInputs */

const en_ui_stat_total_duration = /** @type {(inputs: Ui_Stat_Total_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Duration`)
};

const de_ui_stat_total_duration = /** @type {(inputs: Ui_Stat_Total_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dauer`)
};

/**
* | output |
* | --- |
* | "Total Duration" |
*
* @param {Ui_Stat_Total_DurationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_stat_total_duration = /** @type {((inputs?: Ui_Stat_Total_DurationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Stat_Total_DurationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_stat_total_duration(inputs)
	return de_ui_stat_total_duration(inputs)
});